import { Button, Chip, Stack } from "@mui/material";

export const getColumns = (openDetail) => [

  {
    field: "no",
    headerName: "No",
    width: 60,
    align: "center",
    headerAlign: "center"
  },

  {
    field: "tanggal",
    headerName: "Tanggal",
    headerAlign: "center",
    width: 120
  },

  {
    field: "nip",
    headerName: "NIP",
    headerAlign: "center",
    width: 150
  },

  {
    field: "nama_bawahan",
    headerName: "Nama Bawahan",
    headerAlign: "center",
    flex: 1,
    minWidth: 160
  },

  {
    field: "aktivitas",
    headerName: "Nama Aktivitas",
    headerAlign: "center",
    flex: 1.4,
    minWidth: 200
  },

  {
    field: "status",
    headerName: "Status",
    width: 110,
    align: "center",
    headerAlign: "center",

    renderCell: (params) => {

      const map = {
        disetujui: {
          label: "Disetujui",
          color: "success"
        },
        direvisi: {
          label: "Direvisi",
          color: "warning"
        },
        ditolak: {
          label: "Ditolak",
          color: "error"
        }
      };

      const s = map[params.value] || {
        label: params.value,
        color: "default"
      };

      return (
        <Chip
          label={s.label}
          color={s.color}
          size="small"
        />
      );
    }
  },

  {
    field: "catatan",
    headerName: "Catatan",
    headerAlign: "center",
    flex: 1,
    minWidth: 160
  },

  {
    field: "aksi",
    headerName: "Aksi",
    width: 95,
    align: "center",
    headerAlign: "center",

    renderCell: (params) => (

      <Stack 
        direction="row" 
        spacing={1}
        width="100%"
        height="100%"
        justifyContent="center"
        alignItems="center"
      >
        <Button
          size="small"
          variant="outlined"
          onClick={() => openDetail(params.row)}
          sx={{
            minWidth: 70,
            px: 1
          }}
        >
          Detail
        </Button>
      </Stack>

    )
  }

];